<app-transaction-result-view
[id]="id"
[shouldShowFlow]="true"
[title]="requestVariant === 'personal' ? 'Ampliar mi licencia' : 'Ampliar licencia para un empleado o contratista'"
[subtitle]="subtitle"
[messageBold]="messageBold"
[message]="message"
[actionButtonText]="actionButtonText"
[actionButtonPath]="actionButtonPath"
secondaryButtonText="Crear una nueva solicitud"
secondaryButtonPath="/license/extend"
[breadcrums]="breadcrums"
[actionButtonDescription]="actionButtonDescription"
[variant]="variant"
></app-transaction-result-view>
